module.exports = __webpack_public_path__ + "82725d08d871a5d50b8281ded6f12d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/amazon-com-proxy-voting-information.jpg
// module id = 1612
// module chunks = 0